/* eslint-disable @typescript-eslint/naming-convention */
export enum Status {
  noHistory = 'No History',
  inProgress = 'Proof Request In Progress',
  designDone = 'Design Done',
  licensingReview = 'Design Licensing Review',
  approved = 'Design Approved',
  needChanges = 'Design Needs Change',
  inStudio = 'Order In-Studio',
  inProduction = 'Order In Production',
  outForDelivery = 'Order Out for Delivery',
  delivered = 'Order Delivered',
  orderLive = 'Store Live',
  failedGroupOrder = 'Store Didn’t Hit the Minimum',
}

export enum Page {
  recent = 'Most Recent',
  favorite = 'Favorites',
  design = 'Designs',
  order = 'Orders',
  invoice = 'Invoices',
  inventory = 'Inventory',
  account = 'Account',
  hq = 'HQ',
}

export enum DesignLicenseStatusTypes {
  'Needs Changes' = 'needChanges',
  'Licensing Review' = 'licensingReview',
  'Approved' = 'approved',
}

/** Mixpanel Payment Type labels for Checkout V4 Payment Method Changed. */
export const CHECKOUT_PAYMENT_TYPE_LABELS = {
  CARD: 'Card',
  PAYPAL: 'PayPal',
  GOOGLE_PAY: 'Google Pay',
  APPLE_PAY: 'Apple Pay',
  VENMO: 'Venmo',
  INVOICE: 'Invoice',
} as const;

/** Maps checkout payment method keys to Mixpanel Payment Type display values. */
export const CHECKOUT_PAYMENT_METHOD_TO_TYPE: Record<string, string> = {
  card: CHECKOUT_PAYMENT_TYPE_LABELS.CARD,
  paypal: CHECKOUT_PAYMENT_TYPE_LABELS.PAYPAL,
  googlePay: CHECKOUT_PAYMENT_TYPE_LABELS.GOOGLE_PAY,
  applePay: CHECKOUT_PAYMENT_TYPE_LABELS.APPLE_PAY,
  venmo: CHECKOUT_PAYMENT_TYPE_LABELS.VENMO,
  invoice: CHECKOUT_PAYMENT_TYPE_LABELS.INVOICE,
};

/** Mixpanel Option values for Text Blast Sent. */
export const TEXT_BLAST_SETUP_OPTION = {
  AUTO: 'Auto',
  MANUAL: 'Manual',
} as const;

export type TextBlastSetupOption =
  (typeof TEXT_BLAST_SETUP_OPTION)[keyof typeof TEXT_BLAST_SETUP_OPTION];

/** Mixpanel Type values for Text Blast Sent. */
export const TEXT_BLAST_SENT_TYPE = {
  INVITE: 'Invite',
  REMINDER: 'Reminder',
} as const;

export type TextBlastSentType = (typeof TEXT_BLAST_SENT_TYPE)[keyof typeof TEXT_BLAST_SENT_TYPE];

/** Mixpanel Section values for Text Blast Section Completed. */
export const TEXT_BLAST_SECTION = {
  INVITE_MEMBERS: 'Invite Members',
  ADD_MANUALLY: 'Add Manually',
  ADD_BULK: 'Add Bulk',
} as const;

export type TextBlastSection = (typeof TEXT_BLAST_SECTION)[keyof typeof TEXT_BLAST_SECTION];

/** Mixpanel Category values for Text Blast Sent. */
export const TEXT_BLAST_SENT_CATEGORY = {
  LIVE_STORE: 'Live Store',
  ONE_WEEK_LEFT: '1 week left',
  ONE_DAY_LEFT: '1 day left',
} as const;

interface ITextBlastSentCategoryArgs {
  isLaunchDay: boolean;
  remainingDays?: number;
}

const getTextBlastSentDaysLeftLabel = (remainingDays: number): string => {
  if (remainingDays === 7) {
    return TEXT_BLAST_SENT_CATEGORY.ONE_WEEK_LEFT;
  }

  if (remainingDays === 1) {
    return TEXT_BLAST_SENT_CATEGORY.ONE_DAY_LEFT;
  }

  return `${Math.max(remainingDays, 0)} days left`;
};

/** Launch-day blasts are Live Store; later blasts use days remaining until close. */
export const getTextBlastSentCategory = ({
  isLaunchDay,
  remainingDays,
}: ITextBlastSentCategoryArgs): string => {
  if (isLaunchDay) {
    return TEXT_BLAST_SENT_CATEGORY.LIVE_STORE;
  }

  if (remainingDays == null || Number.isNaN(remainingDays)) {
    return TEXT_BLAST_SENT_CATEGORY.LIVE_STORE;
  }

  return getTextBlastSentDaysLeftLabel(remainingDays);
};
